import Joi from "joi";

const schema = Joi.object({
  title: Joi.string().valid('Mr.', 'Mrs.', 'Dr.', 'Ms.', 'Prof.', 'Er.', 'Sister', 'Rev.', 'Capt.', 'Col.', 'Maj.').optional(),
  firstName: Joi.string().required(),
  lastName: Joi.string().required(),
  
//   email: Joi.string().email().required(),
  
  contactNo: Joi.string()
    .pattern(/^[0-9]{10}$/)
    .message('contactNo must be a valid 10-digit number')
    .required(),
    dob: Joi.date().max("now").allow(null),

//   dob: Joi.date().iso().required(),

  gender: Joi.string().valid('male', 'female', 'other').required(),

  identityProof: Joi.string().valid('aadhar', 'passport', 'pan', 'driving_license').required(), 
  identityNo: Joi.string().required(),

  loginThrough: Joi.string().required(),
  loginPassword: Joi.string().min(6).required(),

  profilePicture: Joi.string().allow(''), 

  userId: Joi.string().required(),

  registrationNumber: Joi.string().allow('').optional(),
  licenseNumber: Joi.string().allow('').optional(),
  regNo: Joi.string().allow('').optional(),

  isIPD: Joi.boolean().optional(),
  isOPD: Joi.boolean().optional(),

  shifts: Joi.array().items(Joi.any()).required() 
}).unknown(true);
export default schema;